var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const getDaysOfMonth = function (month_index) {
	let year = new Date().getFullYear();

	if (year % 100 != 0 && (year % 4 == 0 || year % 400 == 0)) {
		days[1] = 29;
	}

	return days[month_index];
}


// WEBPACK FOOTER //
// ./src/scripts/bisiesto.js